__turbopack_context__.v({
  "numericMenuItem": "NumericMenu-module-scss-module__4U2cuq__numericMenuItem",
  "numericMenuLabel": "NumericMenu-module-scss-module__4U2cuq__numericMenuLabel",
  "numericMenuLabelText": "NumericMenu-module-scss-module__4U2cuq__numericMenuLabelText",
  "numericMenuList": "NumericMenu-module-scss-module__4U2cuq__numericMenuList",
  "numericMenuRadio": "NumericMenu-module-scss-module__4U2cuq__numericMenuRadio",
});
